import * as Yup from 'yup'

export interface IMaxDayDescription {
  maxDay: number
  description: string
}

export interface IInsurancePackageService {
    name: string
  count: number
  description: string
}

export interface IServiceTariffModel {
  id: string
  currency: string
  babySeat: string // BigDecimal → string
  navigation: string
  additionalDriver: string
  internetFee: string
  max_internet_day: number
  childSeat: IMaxDayDescription
  maxNavigation: IMaxDayDescription
  miniDamage: IMaxDayDescription
  SCDW: IMaxDayDescription
  LCF: IMaxDayDescription
  maxAdditionalDriver: IMaxDayDescription
  PAIDescription: string
  IMMDescription: string
  exemptionInsuranceDescription: string
  youngDriverDescription: string
  insurancePackageServiceOne: IInsurancePackageService
  insurancePackageServiceTwo: IInsurancePackageService
  insurancePackageServiceThree: IInsurancePackageService
  insurancePackageServiceFour: IInsurancePackageService
  listingMethod: string
}

export const validationServiceTariff = Yup.object().shape({
  currency: Yup.string().required('Para birimi zorunludur'),
  babySeat: Yup.string().required('Bebek koltuğu sayısı zorunludur'),
  navigation: Yup.string().required('Navigasyon ücreti zorunludur'),
  additionalDriver: Yup.string().required('Ek sürücü ücreti zorunludur'),
  internetFee: Yup.string().required('İnternet ücreti zorunludur'),
  max_internet_day: Yup.number().min(0, 'Negatif olamaz').required('Max internet günü zorunludur'),
  PAIDescription: Yup.string().nullable(),
  IMMDescription: Yup.string().nullable(),
  exemptionInsuranceDescription: Yup.string().nullable(),
  youngDriverDescription: Yup.string().nullable(),
  listingMethod: Yup.string().required('Listeleme yöntemi zorunludur'),
})

export const initialServiceTariff: IServiceTariffModel = {
  id: '',
  currency: '',
  babySeat: '',
  navigation: '',
  additionalDriver: '',
  internetFee: '',
  max_internet_day: 0,
  childSeat: { maxDay: 0, description: '' },
  maxNavigation: { maxDay: 0, description: '' },
  miniDamage: { maxDay: 0, description: '' },
  SCDW: { maxDay: 0, description: '' },
  LCF: { maxDay: 0, description: '' },
  maxAdditionalDriver: { maxDay: 0, description: '' },
  PAIDescription: '',
  IMMDescription: '',
  exemptionInsuranceDescription: '',
  youngDriverDescription: '',
  insurancePackageServiceOne: {name:'', count: 0, description: '' },
  insurancePackageServiceTwo: {name:'', count: 0, description: '' },
  insurancePackageServiceThree: {name: '', count: 0, description: '' },
  insurancePackageServiceFour: { name: '' , count: 0, description: '' },
  listingMethod: '',
}


export const LIST_TYPES = [
  { value: 'Sadece Parktakiler', label: 'Sadece Parktakiler' },
  { value: 'Sadece Sigortalılar', label: 'Sadece Sigortalılar' },
  { value: 'Hepsi', label: 'Hepsi' },
] as const


export const CURRENCY_TYPES = [
    {value: 'TL' , label: 'TL'},
    {value: 'USD' , label: 'USD'},
    {value: 'EUR' , label: 'EUR'},
] as const